import { GraphQLClient } from 'graphql-request'

import useSessionStore from '@/stores/useSessionStore'
import { brand } from '@/utils/brand'

import { getDefaultEndpoint } from './urlHelpers'

/**
 * Creates and returns a memoized GraphQL client for interacting with the API.
 *
 * @param customEndpoint - Optional custom endpoint to override the default GraphQL API endpoint.
 * @param customHeaders - Optional custom headers for additional flexibility.
 * @returns {GraphQLClient} - A GraphQLClient instance.
 */
export const getGraphQLClient = (() => {
  let client: GraphQLClient | null = null
  let lastEndpoint: string | null = null
  let lastHeaders: Record<string, string> | null = null

  return (customEndpoint?: string, customHeaders?: Record<string, string>): GraphQLClient => {
    const authToken = useSessionStore((store) => store.authToken)

    const endpoint = customEndpoint || getDefaultEndpoint()
    const headers = {
      Authorization: `Bearer ${authToken || ''}`,
      Accept: 'application/json',
      'x-brand-id': brand.key,
      'x-user-token': authToken || '',
      ...customHeaders,
    }

    if (
      client &&
      endpoint === lastEndpoint &&
      JSON.stringify(headers) === JSON.stringify(lastHeaders)
    ) {
      return client
    }

    client = new GraphQLClient(endpoint, { headers })
    lastEndpoint = endpoint
    lastHeaders = headers

    return client
  }
})()
